import { graphql } from '@/generated/gql';

export const RISK_COUNTRY_QUERY = graphql(/* GraphQL */ `
  query RiskCountries {
    cataclysm {
      countries {
        id
        area
        riskScores
      }
    }
  }
`);
